module.exports = __webpack_public_path__ + "img/sld_left_arrow.44878205.svg";